import type { BlogPost } from './blog-posts'

/**
 * Global type declarations for blog data in window object
 * This will be populated during build time for production
 */
declare global {
  interface Window {
    __BLOG_DATA__?: {
      posts: BlogPost[];
    };
  }
}

/**
 * Main function to get blog posts
 * Handles both production and development environments
 * 
 * In production: Uses pre-built blog data from window.__BLOG_DATA__
 * In development: Loads posts from markdown files directly
 * 
 * @returns Promise<BlogPost[]> Array of blog posts with content
 */
export async function getBlogPosts(): Promise<BlogPost[]> {
  // Production: Use window.__BLOG_DATA__
  if (typeof window !== 'undefined' && window.__BLOG_DATA__) {
    console.log('Loading blog data from window');
    return window.__BLOG_DATA__.posts;
  }

  console.log('No blog data found');
  return [];
} 